export default __webpack_public_path__ + "bf09d0cdbe72856e4efb45f45c74050b.wav";